<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <vs-row vs-align="center">
          <vs-col vs-lg="4">
            <BusinessSelectFilter
              :multiselect="true"
              v-on:selectBusiness="filterByBuisiness"
            ></BusinessSelectFilter>
          </vs-col>
          <vs-col vs-lg="4">
            <multiselect
                :multiple="true"
                v-model="selectedOrg"
                :options="organizations"
                @input="filterByOrganization"
                label="name"
                track-by="id"
                :internal-search="false"
                :hide-selected="true"
                open-direction="bottom"
                selectLabel=""
                :preserveSearch="true"
                :placeholder="$t('Booking.CreatePrompt.CustomerPlaceholder')"
              >
              </multiselect>
          </vs-col>
          <vs-col vs-lg="2">
            <vs-row vs-align="center">
              <vs-col vs-lg="12">
                <button
                  class="btn btn-primary"
                  style="border-radius: 5px;"
                  @click="businessFilter()"
                >
                  {{ $t("Businesses.FilterButton") }}
                </button>
              </vs-col>
              <vs-col vs-lg="12">
                <!-- Content for the bottom right column -->
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-card>

      <vs-tabs>
        <vs-tab
          :label="$t('Pings.showAll')"
          icon="list_alt"
          id="approved-tab"
          @click="showAll"
        >
          <vs-row vs-justify="center" id="organizations-box">
            <vs-col vs-lg="6">
              <vs-card>
                <div slot="header">
                  <h2 style="text-align: center;">{{ $t("Pings.kiosks") }}</h2>
                  <br />

                  <vs-table
                    :sst="true"
                    v-model="selected"
                    max-items="10"
                    :data="kiosks"
                  >
                    <!-- headers-->
                    <template slot="thead">
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskStatus")
                      }}</vs-th>
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskDate")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.KioskName")
                      }}</vs-th>
                      <vs-th sort-key="business">{{
                        $t("Pings.KioskBussinessName")
                      }}</vs-th>
                      <vs-th>{{ $t("Organization.Table.Options") }}</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
                      <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].last_ping_status">
                          <div class="d-flex align-items-center">
                            <span
                              v-if="data[indextr].last_ping_status == 0"
                              class="status-icon inactive"
                            ></span>
                            <span
                              v-if="data[indextr].last_ping_status == 1"
                              class="status-icon active"
                            ></span>
                            <span v-if="data[indextr].last_ping_status == 0">
                            </span>
                            <span v-if="data[indextr].last_ping_status == 1">
                            </span>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].last_ping_date_time">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <span class="">
                                {{
                                  data[indextr].last_ping_date_time
                                    ? (new Date().getTime() -
                                        new Date(
                                          data[indextr].last_ping_date_time
                                        ).getTime()) /
                                        60000 <
                                      60
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            60000
                                        ).toString() + " minutes ago"
                                        : (new Date().getTime() -
                                          new Date(
                                            data[indextr].last_ping_date_time
                                          ).getTime()) /
                                          3600000 <
                                        24
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            3600000
                                        ).toString() + " hours ago"
                                      : Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            (24 * 3600000)
                                        ).toString() + " day(s) ago"
                                    : "--"
                                }}
                              </span>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].business_name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].business_name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td>
                          <div class="btn-alignment">
                            <vs-button
                              radius
                              color="primary"
                              type="border"
                              icon="visibility"
                              @click="ShowKiosk(data[indextr].id)"
                            ></vs-button>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-card>
            </vs-col>
            <vs-col vs-lg="6">
              <vs-card>
                <div slot="header">
                  <h2 style="text-align: center;">
                    {{ $t("Pings.displays") }}
                  </h2>

                  <br />

                  <vs-table
                    :sst="true"
                    v-model="selected"
                    max-items="10"
                    :data="displays"
                  >
                    <!-- headers-->
                    <template slot="thead">
                      <vs-th sort-key="contactname">{{
                        $t("Pings.DisplayStatus")
                      }}</vs-th>
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskDate")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.DisplayName")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.KioskBussinessName")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.Option")
                      }}</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
                      <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].last_ping_status">
                          <div class="d-flex align-items-center">
                            <span
                              v-if="data[indextr].last_ping_status == 0"
                              class="status-icon inactive"
                            ></span>
                            <span
                              v-if="data[indextr].last_ping_status == 1"
                              class="status-icon active"
                            ></span>
                            <span v-if="data[indextr].last_ping_status == 0">
                            </span>
                            <span v-if="data[indextr].last_ping_status == 1">
                            </span>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].last_ping_date_time">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <span class="">
                                {{
                                  data[indextr].last_ping_date_time
                                    ? (new Date().getTime() -
                                        new Date(
                                          data[indextr].last_ping_date_time
                                        ).getTime()) /
                                        60000 <
                                      60
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            60000
                                        ).toString() + " minutes ago"
                                      : (new Date().getTime() -
                                          new Date(
                                            data[indextr].last_ping_date_time
                                          ).getTime()) /
                                          3600000 <
                                        24
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            3600000
                                        ).toString() + " hours ago"
                                      : Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            (24 * 3600000)
                                        ).toString() + " day(s) ago"
                                    : "--"
                                }}
                              </span>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].business_name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].business_name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td>
                          <div class="btn-alignment">
                            <vs-button
                              radius
                              color="primary"
                              type="border"
                              icon="visibility"
                              @click="ShowDisplay(data[indextr].id)"
                            ></vs-button>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
        </vs-tab>

        <vs-tab
          :label="$t('Pings.notWorking')"
          icon="cancel"
          id="approved-tab"
          @click="notWOrking"
        >
          <vs-row vs-justify="center" id="organizations-box">
            <vs-col vs-lg="6">
              <vs-card>
                <div slot="header">
                  <br />

                  <vs-table
                    :sst="true"
                    v-model="selected"
                    max-items="10"
                    :data="downKiosks"
                  >
                    <!-- headers-->
                    <template slot="thead">
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskStatus")
                      }}</vs-th>
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskDate")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.KioskName")
                      }}</vs-th>
                      <vs-th sort-key="business">{{
                        $t("Pings.KioskBussinessName")
                      }}</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
                      <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].last_ping_status">
                          <div class="d-flex align-items-center">
                            <span
                              v-if="data[indextr].last_ping_status == 0"
                              class="status-icon inactive"
                            ></span>
                            <span
                              v-if="data[indextr].last_ping_status == 1"
                              class="status-icon active"
                            ></span>
                            <span v-if="data[indextr].last_ping_status == 0">
                            </span>
                            <span v-if="data[indextr].last_ping_status == 1">
                            </span>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].last_ping_date_time">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <span class="">
                                {{
                                  data[indextr].last_ping_date_time
                                    ? (new Date().getTime() -
                                        new Date(
                                          data[indextr].last_ping_date_time
                                        ).getTime()) /
                                        60000 <
                                      60
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            60000
                                        ).toString() + " minutes ago"
                                      : (new Date().getTime() -
                                          new Date(
                                            data[indextr].last_ping_date_time
                                          ).getTime()) /
                                          3600000 <
                                        24
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            3600000
                                        ).toString() + " hours ago"
                                      : Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            (24 * 3600000)
                                        ).toString() + " day(s) ago"
                                    : "--"
                                }}
                              </span>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].business_name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].business_name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-card>
            </vs-col>
            <vs-col vs-lg="6">
              <vs-card>
                <div slot="header">
                  <br />

                  <vs-table
                    :sst="true"
                    v-model="selected"
                    max-items="10"
                    :data="downDisplays"
                  >
                    <!-- headers-->
                    <template slot="thead">
                      <vs-th sort-key="contactname">{{
                        $t("Pings.DisplayStatus")
                      }}</vs-th>
                      <vs-th sort-key="joindate">{{
                        $t("Pings.KioskDate")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.DisplayName")
                      }}</vs-th>
                      <vs-th sort-key="contactname">{{
                        $t("Pings.KioskBussinessName")
                      }}</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
                      <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].last_ping_status">
                          <div class="d-flex align-items-center">
                            <span
                              v-if="data[indextr].last_ping_status == 0"
                              class="status-icon inactive"
                            ></span>
                            <span
                              v-if="data[indextr].last_ping_status == 1"
                              class="status-icon active"
                            ></span>
                            <span v-if="data[indextr].last_ping_status == 0">
                            </span>
                            <span v-if="data[indextr].last_ping_status == 1">
                            </span>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].last_ping_date_time">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <span class="">
                                {{
                                  data[indextr].last_ping_date_time
                                    ? (new Date().getTime() -
                                        new Date(
                                          data[indextr].last_ping_date_time
                                        ).getTime()) /
                                        60000 <
                                      60
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            60000
                                        ).toString() + " minutes ago"
                                      : (new Date().getTime() -
                                          new Date(
                                            data[indextr].last_ping_date_time
                                          ).getTime()) /
                                          3600000 <
                                        24
                                      ? Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            3600000
                                        ).toString() + " hours ago"
                                      : Math.floor(
                                          (new Date().getTime() -
                                            new Date(
                                              data[indextr].last_ping_date_time
                                            ).getTime()) /
                                            (24 * 3600000)
                                        ).toString() + " day(s) ago"
                                    : "--"
                                }}
                              </span>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].business_name">
                          <div class="d-flex no-block align-items-center">
                            <div class>
                              <h5 class="mb-0 font-16">
                                {{ data[indextr].business_name }}
                              </h5>
                            </div>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
        </vs-tab>
      </vs-tabs>
    </vs-col>
  </vs-row>
</template>

<script>
import { organizationService, pingsService } from "../../_services";
import axios from "axios";
import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";
import BusinessSelectFilter from "../../components/shared/BusinessSelectFilter";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  name: "monitorings",
  data: () => ({
    title: "monitorings",
    activeDeletePrompt: false,
    totalPages: 0,
    currentPage: 1,
    selected: {},
    test: [],
    displayIds: [],
    selectedId: null,
    kiosks: [],
    organizations: [],
    downKiosks: [],
    currentPingStatus: [],
    downDisplays: {},
    displays: [],
    importModal: {
      file: null,
      active: false,
    },
    name: "",
    address: "",
    phone: "",
    email: "",
    searchKeyword: "",
    selectedOrg: [],
    filter: {
      business: [],
      organizations: [],
      per_page: 20000,
    },
    pingAllInterval: null,
    pingDownInterval: null
  }),
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },

    filterByBuisiness(selected) {
      this.reloadComponents = true;
      this.filter.business = selected.map((obj) => {
        return obj.id;
      });
      this.$nextTick(() => {
        this.reloadComponents = false;
      });
    },

    filterByOrganization(selected) {
      this.reloadComponents = true;
      this.filter.organizations = selected.map((obj) => {
        return obj.id;
      });
      this.$nextTick(() => {
        this.reloadComponents = false;
      });
    },

    businessFilter() {
      // Check if `filter` object is null or empty
      if ((this.filter.business == null || this.filter.business == "") && (this.filter.organizations == null || this.filter.organizations == "")) {
        // If null or empty, call the `getKioskPings` and `getDisplayPings` methods with no filters
        pingsService
          .getKioskPings({ per_page: 2000 })
          .then((data) => {
            this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.kiosks.per_page;
            this.totalPages = data.kiosks.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });

        pingsService
          .getDisplayPings({ per_page: 2000 })
          .then((data) => {
            this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.displays.per_page;
            this.totalPages = data.displays.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
      } else if (Array.isArray(this.filter.business) || Array.isArray(this.filter.organizations)) {
        // If `filter.business` is an array, create a copy of the filter object and modify the `business` property to be a comma-separated string
        const modifiedFilter = {
          per_page: this.filter.per_page
        };
        if(this.filter.business.length > 0 && this.filter.organizations.length == 0) {
          modifiedFilter.business = this.filter.business.join(",");
        } else if (this.filter.business.length == 0 && this.filter.organizations.length > 0) {
          modifiedFilter.organization = this.filter.organizations.join(",");
        } else if (this.filter.business.length > 0 && this.filter.organizations.length > 0) {
          modifiedFilter.business = this.filter.business.join(",");
          modifiedFilter.organization = this.filter.organizations.join(",");
        }
        // Call the `getKioskPings` method with the modified filter object
        pingsService
          .getKioskPings(modifiedFilter)
          .then((data) => {
            this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.kiosks.per_page;
            this.totalPages = data.kiosks.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });

        // Call the `getDisplayPings` method with the modified filter object
        pingsService
          .getDisplayPings(modifiedFilter)
          .then((data) => {
            this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.displays.per_page;
            this.totalPages = data.displays.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        // If the `business` property of `filter` is not an array, call the `getKioskPings` and `getDisplayPings` methods with the original filter object
        pingsService
          .getKioskPings(this.filter)
          .then((data) => {
            this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.kiosks.per_page;
            this.totalPages = data.kiosks.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });

        pingsService
          .getDisplayPings(this.filter)
          .then((data) => {
            this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.displays.per_page;
            this.totalPages = data.displays.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    },

    //show loading
    showLoading() {
      this.$vs.loading({
        container: "#organizations-box",
        scale: 0.6,
      });
    },

    showAll() {
      clearInterval(this.pingAllInterval);
      clearInterval(this.pingDownInterval);
      this.showLoading();
      const getOrganizationData = () => {
        pingsService
          .getKioskPings({ per_page: 2000 })
          .then((data) => {
            this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.kiosks.per_page;
            this.totalPages = data.kiosks.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
      };

      const getResellerData = () => {
        pingsService
          .getDisplayPings({ per_page: 2000 })
          .then((data) => {
            this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
            this.maxItems = data.displays.per_page;
            this.totalPages = data.displays.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
      };

      getOrganizationData();
      getResellerData();

      this.pingAllInterval = setInterval(() => {
        getOrganizationData();
        getResellerData();
      }, 300000);
    },

    notWOrking() {
      clearInterval(this.pingAllInterval);
      clearInterval(this.pingDownInterval);
      this.showLoading();
      const getOrganizationData = () => {
        pingsService
          .getDownDisplays()
          .then((data) => {
            this.downDisplays = Object.values(data.displays);
          })
          .finally(() => {
            this.hideLoading();
            console.log(this.downDisplays);
          });
      };

      const getResellerData = () => {
        pingsService
          .getDownKiosk()
          .then((data) => {
            this.downKiosks = Object.values(data.displays);
          })
          .finally(() => {
            this.hideLoading();
            console.log(this.downKiosks);
          });
      };

      getOrganizationData();
      getResellerData();

      this.pingDownInterval = setInterval(() => {
        getOrganizationData();
        getResellerData();
      }, 300000);
    },

    ShowKiosk(kiosk_id) {
      const routeData = this.$router.resolve({
        path: "/kiosks/show/" + kiosk_id,
        query: { data: "someData" },
      });
      window.open(routeData.href, "_blank");
      // Play the audio
    },
    ShowDisplay(Display_id) {
      const routeData = this.$router.resolve({
        path: "/display/show/" + Display_id,
        query: { data: "someData" },
      });
      window.open(routeData.href, "_blank");
    },

    //hide loeading
    hideLoading() {
      this.$vs.loading.close("#organizations-box > .con-vs-loading");
    },

    //pagination js
    handleChangePage() {
      this.showLoading();
      pingsService
        .getKioskPings({ current_page: this.currentPage })
        .then(
          function(data) {
            this.kiosks = data.kiosks.data;
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },

    getAllOrganization() {
      organizationService
        .getAll()
        .then(
          function(res) {
            this.organizations = res.organizations.data;
          }.bind(this)
        )
        .finally(() => {;
        });
    },
    //create organisation
  },
  //before starting the

  beforeMount() {
    this.getAllOrganization();
    //const connectionSound = new Audio('http://codeskulptor-demos.commondatastorage.googleapis.com/pang/pop.mp3');
    //connectionSound.play();
    pingsService
      .getKioskPings({ per_page: 2000 })
      .then((data) => {
        this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
        this.maxItems = data.kiosks.per_page;
        this.totalPages = data.kiosks.last_page;
      })
      .finally(() => {
        this.hideLoading();
      });

    pingsService
      .getDisplayPings({ per_page: 2000 })
      .then((data) => {
        this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
        this.maxItems = data.displays.per_page;
        this.totalPages = data.displays.last_page;
      })
      .finally(() => {
        this.hideLoading();
    });
    this.pingAllInterval = setInterval(() => {
    pingsService
      .getKioskPings({ per_page: 2000 })
      .then((data) => {
        this.kiosks = data.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
        this.maxItems = data.kiosks.per_page;
        this.totalPages = data.kiosks.last_page;
      })
      .finally(() => {
        this.hideLoading();
      });

    pingsService
      .getDisplayPings({ per_page: 2000 })
      .then((data) => {
        this.displays = data.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
        this.maxItems = data.displays.per_page;
        this.totalPages = data.displays.last_page;
      })
      .finally(() => {
        this.hideLoading();
      });
    }, 300000);

    
  },

  mounted() {
    let lastKioskPingStatus = null;
    let lastDisplayPingStatus = null;
    const connectionSound = new Audio(
      "http://codeskulptor-demos.commondatastorage.googleapis.com/descent/gotitem.mp3"
    );

    setInterval(() => {
      if(this.filter.business != null) {
      let pingStatusChanged = false; // initialize pingStatusChanged to false
      // Get kiosk pings and display pings
      const businessString = this.filter.business.join(",");

      const queryArgs = businessString
        ? { business: businessString, per_page: 2000 }
        : { per_page: 2000 };
      Promise.all([
        pingsService.getKioskPings(queryArgs),
        pingsService.getDisplayPings(queryArgs),
      ])
        .then((responses) => {
          // Check kiosk pings
          const kioskData = responses[0];
          this.kiosks = kioskData.kiosks.data.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
          this.maxItems = kioskData.kiosks.per_page;
          this.totalPages = kioskData.kiosks.last_page;

          for (const kiosk of this.kiosks) {
            const currentPingStatus = kiosk.last_ping_status;
            // console.log(`Kiosk: ${kiosk.id} - Old Ping Status: ${lastKioskPingStatus} - New Ping Status: ${currentPingStatus}`);

            if (
              lastKioskPingStatus !== null &&
              lastKioskPingStatus !== currentPingStatus
            ) {
              // Set pingStatusChanged to true if a change is detected
              pingStatusChanged = true;
            }
            lastKioskPingStatus = currentPingStatus;
          }

          // Check display pings
          const displayData = responses[1];
          this.displays = displayData.displays.sort((a, b) => Number(a.last_ping_status) - Number(b.last_ping_status));
          this.maxItems = displayData.displays.per_page;
          this.totalPages = displayData.displays.last_page;

          for (const display of this.displays) {
            const currentPingStatus = display.last_ping_status;
            //  console.log(`Display: ${display.id} - Old Ping Status: ${lastDisplayPingStatus} - New Ping Status: ${currentPingStatus}`);

            if (
              lastDisplayPingStatus !== null &&
              lastDisplayPingStatus !== currentPingStatus
            ) {
              // Set pingStatusChanged to true if a change is detected
              pingStatusChanged = true;
            }
            lastDisplayPingStatus = currentPingStatus;
          }

        })
        .finally(() => {
          this.hideLoading();

          // Play the sound if pingStatusChanged is true
          if (pingStatusChanged) {
            connectionSound.play();
          }
        });
      }
    }, 300000);
  },

  components: {
    CustomizerSidebar,
    BusinessSelectFilter,
    Multiselect
  },
};
</script>

<style>
.colorDisp {
  color: black;
}
.status-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}

.inactive {
  background-color: red;
}

.active {
  background-color: green;
}
</style>
